import React, { memo } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '@saleshandy/design-system';
import { RotateAnticlockwiseDots } from '@saleshandy/icons';
import { formatPhoneNumber } from '../../../../../../helpers/utils/get-formated-numbers';
import type { IProps } from './types';

const RevokeReleaseModal: React.FC<IProps> = ({
  show,
  onClose,
  phoneNumber,
  onSubmit,
  isLoading = false,
}) => {
  const handleConfirm = () => {
    onSubmit?.();
  };

  const handleCancel = () => {
    onClose();
  };

  const formattedPhoneNumber = formatPhoneNumber(
    phoneNumber.phoneNumber,
    phoneNumber.isoCountry,
  );
  const numberType =
    phoneNumber.friendlyName || phoneNumber.numberType || 'Number';
  const numberTypeLabel = numberType ? `(${numberType})` : '';

  const title = (
    <div className="d-flex align-items-center gap-10">
      <RotateAnticlockwiseDots width={24} height={24} color="#D97706" />
      <span className="line-height-1">
        Are you sure you want to revoke the release?
      </span>
    </div>
  );

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      aria-labelledby="revoke-release-modal-title"
      className="revoke-release-modal"
      backdrop="static"
      centered
    >
      <Modal.Header className="revoke-release-modal__header">
        <Modal.Title
          id="revoke-release-modal-title"
          className="revoke-release-modal__title"
        >
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="revoke-release-modal__body">
        <p className="revoke-release-modal__description">
          Revoking the release will cancel the pending release for{' '}
          <span className="revoke-release-modal__description__phone-number">
            {formattedPhoneNumber}
            {numberTypeLabel}
          </span>{' '}
          and the number will remain active in your account.
        </p>
      </Modal.Body>
      <Modal.Footer className="revoke-release-modal__footer">
        <div className="revoke-release-modal__footer-actions">
          <Button
            onClick={handleCancel}
            variant="secondary"
            className="revoke-release-modal__cancel-btn"
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            className="revoke-release-modal__confirm-btn"
            disabled={isLoading}
            isLoading={isLoading}
            loadingText="Revoking"
          >
            Yes, Revoke
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default memo(RevokeReleaseModal);
